import { create } from 'zustand';

export type ChatTheme = 'radio' | 'messenger' | 'minimal' | 'retro';

export interface ThemeConfig {
  key: ChatTheme;
  label: { ko: string; en: string };
  // App-wide
  appBg: string;
  surfaceBg: string;
  cardBg: string;
  headerBg: string;
  borderColor: string;
  textColor: string;
  textMuted: string;
  // Chat specific
  chatBg: string;
  myBubbleBg: string;
  myBubbleBorder: string;
  otherBubbleBg: string;
  otherBubbleBorder: string;
  myTextColor: string;
  otherTextColor: string;
  inputBg: string;
  inputBorder: string;
}

export const THEMES: ThemeConfig[] = [
  {
    key: 'radio',
    label: { ko: '무전기', en: 'Radio' },
    appBg: '#0a0a0f', surfaceBg: '#1E1E1E', cardBg: '#2C2C2C', headerBg: '#1a1a1a',
    borderColor: '#333', textColor: '#E0E0E0', textMuted: '#888',
    chatBg: '#1a2d1a', myBubbleBg: '#1c2e1c', myBubbleBorder: '#FFB300',
    otherBubbleBg: '#1e301e', otherBubbleBorder: '#39FF14',
    myTextColor: '#90EE90', otherTextColor: '#90EE90', inputBg: '#0d1a0d', inputBorder: '#3c5c3c',
  },
  {
    key: 'messenger',
    label: { ko: '메신저', en: 'Messenger' },
    appBg: '#0f0f1a', surfaceBg: '#1a1a30', cardBg: '#252545', headerBg: '#15152a',
    borderColor: '#303050', textColor: '#e0e0f0', textMuted: '#8888aa',
    chatBg: '#1a1a2e', myBubbleBg: '#0066cc', myBubbleBorder: '#0077dd',
    otherBubbleBg: '#303050', otherBubbleBorder: '#404060',
    myTextColor: '#ffffff', otherTextColor: '#e0e0f0', inputBg: '#252540', inputBorder: '#404060',
  },
  {
    key: 'minimal',
    label: { ko: '미니멀', en: 'Minimal' },
    appBg: '#141414', surfaceBg: '#1e1e1e', cardBg: '#282828', headerBg: '#1a1a1a',
    borderColor: '#383838', textColor: '#e0e0e0', textMuted: '#888',
    chatBg: '#1e1e1e', myBubbleBg: '#2d2d2d', myBubbleBorder: '#444',
    otherBubbleBg: '#252525', otherBubbleBorder: '#383838',
    myTextColor: '#e0e0e0', otherTextColor: '#c0c0c0', inputBg: '#2a2a2a', inputBorder: '#444',
  },
  {
    key: 'retro',
    label: { ko: '레트로', en: 'Retro' },
    appBg: '#05050f', surfaceBg: '#0a0a1a', cardBg: '#151525', headerBg: '#080818',
    borderColor: '#252540', textColor: '#e0e0ff', textMuted: '#8080aa',
    chatBg: '#0a0a1a', myBubbleBg: '#1a0a2a', myBubbleBorder: '#ff00ff80',
    otherBubbleBg: '#0a1a2a', otherBubbleBorder: '#00ffff60',
    myTextColor: '#ff88ff', otherTextColor: '#88ffff', inputBg: '#0a0a1a', inputBorder: '#ff00ff40',
  },
];

interface ThemeState {
  chatTheme: ChatTheme;
  setChatTheme: (theme: ChatTheme) => void;
  getThemeConfig: () => ThemeConfig;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  chatTheme: (localStorage.getItem('ourhertz_chat_theme') as ChatTheme) ?? 'radio',

  setChatTheme: (theme) => {
    localStorage.setItem('ourhertz_chat_theme', theme);
    set({ chatTheme: theme });
  },

  getThemeConfig: () => {
    return THEMES.find(t => t.key === get().chatTheme) ?? THEMES[0];
  },
}));
